












































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { ContentStreamDTO } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "ContentStreamForm",
		components: { ButtonList }
	})
export default class ContentStreamForm extends ParticaBaseForm<ContentStreamDTO> {

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name", label: "Name", } as FormFieldProps,
			rules: { required: true, max: 200, min: 0, } as FormFieldRules
		} as IFormField;

	private descriptionconfig =
		{
			props: { name: "description", placeholder: "Enter description", label: "Description", } as FormFieldProps,
			rules: { required: true, max: 500, min: 0, } as FormFieldRules
		} as IFormField;

	private statusconfig =
		{
			props: {					name: "status", placeholder: "Choose status", label: "Status", required: true,
				values: [{ label: "Active", value: "active" } as EnumDTO, { label: "Inactive", value: "inactive" } as EnumDTO,],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private oldvisibilityconfig =
		{
			props: {					name: "visibility", placeholder: "Choose visibility", label: "Visibility", required: true, disabled: true,
				values: [
					{ label: "Private Stream", value: "privateStream" } as EnumDTO,
					{ label: "Partner Billing", value: "nonBilledStream" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;
	private visibilityconfig =
		{
			props: {
				name: "visibility",
				placeholder: "Choose visibility",
				label: "visibility", required: true, disabled: true,
				values: [
					{ label: "Private Chargebee Billed Stream", value: "privateChargebeeBilledStream" } as EnumDTO,
					{ label: "Non Chargebee Billed Stream", value: "nonChargebeeBilledStream" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private ownerconfig =
		{
			props: {
				name: "owner",
				placeholder: "Owner",
				label: "Stream Owner", required: true, disabled: true,
				values: [
					{ label: "Partica", value: "partica" } as EnumDTO,
					{ label: "Corelogic", value: "corelogic" } as EnumDTO,
					{ label: "MyDesign", value: "myDesign" } as EnumDTO,
					{ label: "ActivePipe", value: "activePipe" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private oldownerconfig =
		{
			props: {
				name: "owner",
				placeholder: "Choose Owner",
				label: "Owner", required: true, disabled: true,
				values: [
					{ label: "Partica", value: "partica" } as EnumDTO,
					{ label: "MyDesign", value: "myDesign" } as EnumDTO,
					{ label: "Core Logic", value: "corelogic" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private categoryconfig =
		{
			props: {
				name: "category",
				placeholder: "Choose category",
				label: "Category", required: true, disabled: true, values: [{ label: "Real Estate", value: "realEstate" } as EnumDTO,],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private copyIssueOnSubscribeconfig =
		{
			props: {
				name: "copyIssueOnSubscribe",
				placeholder: "Choose what to copy when a user subscribes.",
				label: "Initial articles for subscriber.", required: true,
				values: [
					{ label: "Do not copy any articles (stream).", value: "none" } as EnumDTO,
					{ label: "Copy articles from first issue (bucket).", value: "first" } as EnumDTO,
					{ label: "Copy articles from most recent issue (bucket).", value: "last" } as EnumDTO
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;


	@Watch("model.id")
	private propwatch() {
		if (this.model.id === 0) {
			this.ownerconfig.props.disabled = false;
			this.visibilityconfig.props.disabled = false;
			this.categoryconfig.props.disabled = false;
			this.copyIssueOnSubscribeconfig.props.disabled = false;
		} else {
			this.ownerconfig.props.disabled = true;
			this.copyIssueOnSubscribeconfig.props.disabled = true;
			this.visibilityconfig.props.disabled = true;
			this.categoryconfig.props.disabled = true;
		}
	}

	private mounted() {
		this.propwatch();
	}
}
